//@flow
import * as React from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.Node,
  onOpen?: Function,
  onClose?: Function,
};

class ModalWrapper extends React.Component<Props> {
  modalRoot = document.createElement('section');
  modal = document.createElement('div');
  lastFocus: HTMLElement;
  focusCapture: any;
  closeModalButton: HTMLElement | null;

  captureFocus(event: any) {
    if (this.modal && !this.modal.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
      this.focusModal();
    }
  }

  focusModal() {
    if (
      this.closeModalButton &&
      !document.activeElement.isEqualNode(this.closeModalButton)
    ) {
      this.closeModalButton.focus();
    }
  }

  determineLastFocus() {
    if (document.activeElement !== document.body) {
      if (document.activeElement) this.lastFocus = document.activeElement;
    } else {
      if (window.lastSubmittedForm)
        this.lastFocus = window.lastSubmittedForm.querySelector(
          '[type="submit"]'
        );
    }
  }

  componentDidMount() {
    this.determineLastFocus();
    if (this.props.onOpen) this.props.onOpen();
    this.modal.classList.add('modal-wrapper');
    this.modalRoot.setAttribute('id', 'modal-root');
    if (document.body) document.body.appendChild(this.modalRoot);
    this.modalRoot.appendChild(this.modal);
    this.closeModalButton = this.modal.querySelector('.modal-close');
    this.focusModal();
    this.focusCapture = this.captureFocus.bind(this);
    document.addEventListener('focus', this.focusCapture, true);
  }

  componentWillUnmount() {
    if (document.body) document.body.removeChild(this.modalRoot);
    document.removeEventListener('focus', this.focusCapture, true);
    if (this.lastFocus) this.lastFocus.focus();
    if (this.props.onClose) this.props.onClose();
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.modal);
  }
}

export default ModalWrapper;
